import React, { useEffect, useState } from 'react'
import { IoIosArrowDown } from "react-icons/io";
import './style/navbar.css'
import { PiPhoneCallFill } from "react-icons/pi";
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderLine from '../line/HeaderLine';
import { CiHeart } from "react-icons/ci";
import Logo from '../Logo/Logo';
import { openWhislist } from '../../../Redux/Action/action';
import { useDispatch, useSelector } from 'react-redux';

function Navbar2() {

    const [navbarBackground, setNavbarBackground] = useState('transparent');
    const [navbarTextColor, setNavbarTextColor] = useState('white');
    const [scrollIconColor, setScrollIconColor] = useState('white');
    const [scrollBorderColor, setScrollBorderColor] = useState('0.25px solid white');
    const [state, setState] = useState({ right: false, sidebarHeight: "100vh" });

    const isopen = useSelector(state => state.wishlist.Whislist);

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();

    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"

        });
        navigate("/");
    };

    const callus = () => {
        window.location.href = "tel:+32483001517";
    };
    useEffect(() => {
        window.onscroll = function () { myFunction() };

        const header = document.getElementById("myHeader");

        const sticky1 = header.offsetTop;

        function myFunction() {
            if (window.pageYOffset > sticky1) {
                header.classList.add("sticky1");
            } else {
                header.classList.remove("sticky1");
            }
        }
    }, []);
    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 100) {
            setNavbarBackground('white');
            setNavbarTextColor('gray');
            setScrollIconColor('black');
            setScrollBorderColor('0.25px solid #8080806e')
        } else {
            setNavbarBackground('transparent');
            setNavbarTextColor('white');
            setScrollIconColor('white');
            setScrollBorderColor('0.25px solid white')
        }
    };

    useEffect(() => {
        if (location.pathname === '/') {
            window.addEventListener('scroll', handleScroll);
        } else {
            setNavbarBackground('white');
            setNavbarTextColor('gray');
            setScrollIconColor('black');
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location]);

    const handleIconButtonClick = (event) => {
        if (!isopen) {
            event.stopPropagation();
        }
        toggleDrawer1('right', true)(event);
        dispatch(openWhislist(true));
    };

    const toggleDrawer1 = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
        if (!open) {
            dispatch(openWhislist(false));
        }
    };
    return (
        <div className='navbar-hide-sm'>
            <HeaderLine />
            <div id="myHeader" className={`z-50 w-full fixed`} style={{ backgroundColor: navbarBackground, color: navbarTextColor, borderBottom: scrollBorderColor }}>
                <div className='flex justify-around items-center'>
                    <div><Logo key={0} /></div>
                    {/* <p style={{ color: scrollIconColor }} className='uppercase text-2xl font-semibold tracking-wider cursor-pointer' onClick={()=>navigate("/")}>stellare bijoux</p> */}
                    <ul className="flex  justify-between ">
                        <li className="p-1 nav-label mt-1 cursor-pointer text-sm" onClick={scrollTop}>HOME</li>
                        <li className="p-1 dropdown ">
                            <p className="dropbtn flex nav-label cursor-pointer text-sm " style={{ color: navbarTextColor }}>PRODUCTS <IoIosArrowDown className="m-1" /></p>
                            <ul className="dropdown-content">
                                <li className='cursor-pointer text-sm' onClick={() => navigate("/category")}>Ring</li>
                                <li className='cursor-pointer text-sm' onClick={() => navigate("/category")}>Necklace</li>
                                <li className='cursor-pointer text-sm' onClick={() => navigate("/category")}>Chain</li>
                                <li className='cursor-pointer text-sm' onClick={() => navigate("/category")}>Earring</li>
                                <li className='cursor-pointer text-sm' onClick={() => navigate("/category")}>Bracelet</li>
                                <li className='cursor-pointer text-sm' onClick={() => navigate("/category")}>Bangle</li>
                            </ul>
                        </li>
                        <li className="p-1 nav-label mt-1 cursor-pointer text-sm" onClick={() => navigate("/About-us")}>ABOUT US</li>
                        <li className="p-1 nav-label mt-1 cursor-pointer text-sm" onClick={() => navigate("/Contact-us")}>CONTACT US</li>
                        <li>
                        </li>
                    </ul>

                    <div className="flex justify-between" style={{ paddingRight: '5px' }}>

                        <div onClick={callus} style={{ color: scrollIconColor, paddingLeft: '10px', cursor: 'pointer' }} className="text-2xl text-white">
                            <PiPhoneCallFill />
                        </div>
                        <div className=" text-2xl block" onClick={handleIconButtonClick} style={{ color: scrollIconColor, paddingLeft: '10px', cursor: 'pointer' }}>
                            <CiHeart />
                        </div>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default Navbar2
